import {
  all, call, put, takeLatest,
} from 'redux-saga/effects'
import { ReturnCall } from '../../types'
import { actions as appActions } from '../../state'
import { PayloadAction } from '@reduxjs/toolkit'
import {
  CheckRemotePrinterHealthPayload, GetActivePrintersPayload, RaspberryFeaturesEnum, SaveLocalPrinterSettingsPayload,
} from './PrintersManagementTypes'
import { toast } from 'react-toastify'
import { actions } from './PrintersManagementState'
import apis from './PrintersManagementApi'

function* getLocalPrinter() {
  try {
    yield put(actions.setProperty({ property: 'isRaspberrySoulConnected', value: false }))
    yield put(actions.setProperty({ property: 'localPrinter', value: undefined }))

    const result: ReturnCall<typeof apis.getLocalPrinter> = yield call(
      apis.getLocalPrinter,
    )

    if (!result.isOk && result?.data?.data?.message === 'PRINTER_DISCONNECTED') {
      yield put(actions.setProperty({ property: 'isRaspberrySoulConnected', value: true }))
      return
    }

    if (!result.isOk) {
      return
    }

    if (result.isOk && !result.data?.features?.includes(RaspberryFeaturesEnum.TAG_FRACTION_PRINT)) {
      toast.warn('Alma desatualizada!')
      return
    }

    yield put(actions.setProperty({ property: 'isRaspberrySoulConnected', value: true }))
    yield put(actions.setProperty({ property: 'localPrinter', value: result.data }))
  } catch (err: any) {
    // eslint-disable-next-line no-console
    console.error(`Não foi possível obter informações da alma: ${err}`)
  }
}

function* getActivePrinters(data: PayloadAction<GetActivePrintersPayload>) {
  yield put(appActions.isLoading(true))

  const { fulfillmentCenterId, onSuccess, onError } = data.payload

  try {
    const result: ReturnCall<typeof apis.getActivePrinters> = yield call(
      apis.getActivePrinters,
      fulfillmentCenterId,
    )

    if (!result.isOk) {
      toast.error(result?.data?.data?.message || 'Falha ao carregar impressoras ativas')
      onError()
      return
    }

    yield put(actions.setProperty({ property: 'printers', value: result.data }))

    onSuccess()
  } catch (err: any) {
    toast.error('Falha ao carregar impressoras ativas!')
    onError()
  } finally {
    yield put(appActions.isLoading(false))
  }
}

function* saveLocalPrinterSettings(data: PayloadAction<SaveLocalPrinterSettingsPayload>) {
  yield put(appActions.isLoading(true))

  const { onSuccess, onError } = data.payload

  try {
    const result: ReturnCall<typeof apis.saveLocalPrinterSettings> = yield call(
      apis.saveLocalPrinterSettings,
      data.payload,
    )

    if (!result.isOk) {
      toast.error(result?.data?.data?.message || 'Falha ao salvar configurações da impressora local')
      onError()
      return
    }

    onSuccess()
  } catch (err: any) {
    toast.error('Falha ao salvar configurações da impressora local!')
    onError()
  } finally {
    yield put(appActions.isLoading(false))
  }
}

function* checkRemotePrinterHealth(data: PayloadAction<CheckRemotePrinterHealthPayload>) {
  yield put(appActions.isLoading(true))

  const { ip, onSuccess, onError } = data.payload

  try {
    const result: ReturnCall<typeof apis.checkRemotePrinterHealth> = yield call(
      apis.checkRemotePrinterHealth,
      ip,
    )

    if (!result.isOk && result?.data?.data?.message === 'PRINTER_DISCONNECTED') {
      toast.error('Impressora do dispositivo desconectada!')
      onError()
      return
    }

    if (!result.isOk) {
      toast.error('Falha ao verificar saúde da impressora remota!')
      onError()
      return
    }

    if (result.isOk && !result.data?.features?.includes(RaspberryFeaturesEnum.TAG_FRACTION_PRINT)) {
      toast.warn('Alma do dispositivo remoto desatualizada!')
      onError()
      return
    }

    onSuccess()
  } catch (err: any) {
    toast.error('Falha ao verificar saúde da impressora remota!')
    onError()
  } finally {
    yield put(appActions.isLoading(false))
  }
}

export default function* () {
  yield all([
    takeLatest(actions.getLocalPrinter.type, getLocalPrinter),
    takeLatest(actions.getActivePrinters.type, getActivePrinters),
    takeLatest(actions.saveLocalPrinterSettings.type, saveLocalPrinterSettings),
    takeLatest(actions.checkRemotePrinterHealth.type, checkRemotePrinterHealth),
  ])
}
